export function renderWithRequiredIndicator(value: string, isRequired: boolean) {
    if (isRequired) {
        return `${value} *`;
    }
    return value;
}